import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const deviceRealtimeListeners: SocketEventListener[] = [
  {
    event: 'deviceEvent',
    handler: (msg: any) => {
      console.log('socket io - deviceEvents', msg);
      emitter.emit(EMITTER_CONSTANTS.DEVICE_EVENT, msg);
    },
  },
  {
    event: 'lastSync',
    handler: (msg: any) => {
      console.log('socket io - lastSyncListener', msg);
      emitter.emit(EMITTER_CONSTANTS.LAST_SYNC, msg);
    },
  },
  {
    event: 'ecgUploadProgress',
    handler: (msg: any) => {
      console.log('socket io - ecgUploadProgressListener', msg);
      emitter.emit(EMITTER_CONSTANTS.ECG_UPLOAD_PROCESS, msg);
    },
  },
  {
    event: 'biodirectEvent',
    handler: (msg: any) => {
      console.log('socket io - biodirectEventListener', msg);
      emitter.emit(EMITTER_CONSTANTS.BIODIRECT_EVENT, msg);
    },
  },
  {
    event: 'SendStudyDeviceConnectionStatus',
    handler: (msg: any) => {
      console.log('socket io - SendStudyDeviceConnectionStatus', msg);
      emitter.emit(EMITTER_CONSTANTS.SEND_DEVICE_CONNECTION_STATUS, msg);
    },
  },
  {
    event: 'uploadStatus',
    handler: (msg: any) => {
      console.log('socket io - uploadStatusListener', msg);
      emitter.emit(EMITTER_CONSTANTS.UPLOAD_STATUS, msg);
    },
  },
];

export default deviceRealtimeListeners;
